import classNames from 'classnames';
import React from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {ExpressiveIcon} from '@udemy/icons-expressive';
import {Button} from '@udemy/react-core-components';

import {OPEN_BADGES_BASE_PATH} from './constants';
import style from './empty-assertion-style.module.less';

interface EmptyAssertionStateProps {
    isOwner: boolean;
}

export const EmptyAssertionState = ({isOwner}: EmptyAssertionStateProps) => {
    const isMobileMax = useMatchMedia('mobile-max');
    const {gettext} = useI18n();

    const noContentHeadingForOwner = gettext('You have no learning content related to this badge');
    const noContentHeadingForNonOwner = gettext('No learning content related to this badge');
    const noContentTextForOwner = gettext(
        'Currently, there is no learning content related to this badge associated with your account. ' +
            'Udemy offers an extensive collection of certification preparation content that can help ' +
            'you prepare for your next certification.',
    );
    const noContentTextForNonOwner = gettext(
        'This user has no learning content related to this badge associated with this account.',
    );

    const exploreCertPrepButton = (
        <Button
            udStyle="primary"
            size="large"
            href={OPEN_BADGES_BASE_PATH}
            componentClass={'a'}
            data-purpose="explore-certification-preparation-button"
        >
            {gettext('Explore certification preparation')}
        </Button>
    );

    return (
        <div
            className={classNames(style['assertion-empty-state'])}
            data-purpose="assertion-empty-state"
        >
            <ExpressiveIcon
                className={classNames(style['empty-state-icon'])}
                data-purpose="certification-icon"
                name="certificate"
                size={isMobileMax ? 'small' : 'medium'}
            />
            <div
                className={classNames('ud-heading-xl', style['assertion-empty-state-text'])}
                data-purpose={'assertion-empty-state-text-heading'}
            >
                {isOwner ? noContentHeadingForOwner : noContentHeadingForNonOwner}
            </div>
            <div
                className={classNames('ud-text-md', style['assertion-empty-state-text'])}
                data-purpose={'assertion-empty-state-text'}
            >
                {isOwner ? noContentTextForOwner : noContentTextForNonOwner}
            </div>
            {isOwner && exploreCertPrepButton}
        </div>
    );
};
